import React from 'react';
import { MarketsView } from '../../components/MarketsView';
export default function Markets() {
  return <div data-testid="dashboard-markets"><MarketsView embedded /></div>;
}
